import { useZocksQuota } from '../../../../components/ScopedBlock/hooks'

export const useCrossClientRemainingQueries = () => {
  const { getQuotaValue, isFetching } = useZocksQuota()
  const maxCcQueriesPerWeek = getQuotaValue('ai.maxCcQueriesPerWeek.value') ?? 0
  const usedCcQueriesPerWeek = getQuotaValue('ai.usedCcQueriesPerWeek.value') ?? 0
  const remainingCcQueriesPerWeek = Math.max(maxCcQueriesPerWeek - usedCcQueriesPerWeek, 0)

  return { maxCcQueriesPerWeek, usedCcQueriesPerWeek, remainingCcQueriesPerWeek, quotaLoading: isFetching }
}
